<template>
	<div id="pagination">
		<div class="e-control e-toolbar e-lib e-keyboard">
			<div class="e-toolbar-items e-tbar-pos">
				<div class="e-toolbar-center">
					<div class="e-toolbar-item pages" title="Previous" @click="pdfViewer?.value?.navigation?.goToPreviousPage()">
						<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
							<span class="e-btn-icon e-pv-previous-page-navigation-icon e-icons" />
						</button>
					</div>
					<div class="e-toolbar-item total-page-container">
						<span>/ {{ pdfViewer?.value?.pageCount }}</span>
					</div>
					<div class="e-toolbar-item pages" title="Next" @click="pdfViewer?.value?.navigation?.goToNextPage()">
						<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn">
							<span class="e-btn-icon e-pv-next-page-navigation-icon e-icons" />
						</button>
					</div>
				</div>
			</div>
		</div>
		<task-counter>
			<button v-if="!isClient" class="endCall" @click="$emit(`endCall`)">
				End Call
			</button>
		</task-counter>
	</div>
</template>
<script>
import TaskCounter from "./TaskCounter.vue";
export default {
	components: { TaskCounter },
	inject: {
		pdfViewer: { type: Object },
	},
	props: {
		isClient: { type: Boolean, default: true }
	},
	emits: [`endCall`]
};
</script>